import { render } from "./EditComptePage.vue?vue&type=template&id=9d2babc2&ts=true"
import script from "./EditComptePage.vue?vue&type=script&lang=ts"
export * from "./EditComptePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__